import React, { Component, Fragment } from "react";

import ParticlesComponent from "../../components/particles/ParticlesComponent";
import Intro from "../../containers/intro/Intro";
import NavBar from "../../components/navbar/NavBar";
import About from "../../containers/about/About";
import Career from "../../containers/career/Career";
import Skills from "../../containers/skills/Skills";
import Projects from "../../containers/projects/Projects";
import Contact from "../../containers/contact/Contact";
import "./Home.scss";
import { faTintSlash } from "@fortawesome/free-solid-svg-icons";

class Home extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: props.data
        };
    }

    render() {

        let backgroundImage = this.state.data.backgroundImage;

        return (
            <Fragment>
                <div className="main-bg" style={{ backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.65), rgba(0, 0, 0, 0.65)), url(/images/${backgroundImage})` }}>
                    <ParticlesComponent />
                    <Intro data={this.state.data} />
                    <NavBar data={this.state.data} />
                </div>
                <About data={this.state.data} />
                {/* <WriteUps /> */}
                <Career data={this.state.data} />
                <Skills data={this.state.data} />
                <Projects data={this.state.data} />
                <Contact data={this.state.data} />
            </Fragment>
        );
    }
};

export default Home;